module.exports = __webpack_public_path__ + "img/NFTCN-logo.ce0d0ced.png";